'use client'

// SignalMarks — walker signals floating where they were sent. Ambient
// multiplayer presence: the sim echoes every signal to every viewer, so a
// busy evening reads as a city with people in it. Renders via drei's Html
// (DOM projected into the scene), which sidesteps WebGPU material work for
// something this small and short-lived.

import { useEffect } from 'react'
import { Html } from '@react-three/drei'
import useGameStore from '../../../stores/gameStore'
import { SignalGlyph } from '../../ui/SignalGlyphs'

export function SignalMarks() {
  const signals = useGameStore((s) => s.activeSignals)
  const pruneSignals = useGameStore((s) => s.pruneSignals)

  // Expired marks would otherwise linger in the store until the next add;
  // a slow prune keeps the list honest while anything is on screen.
  useEffect(() => {
    if (!signals.length) return
    const t = setInterval(pruneSignals, 1500)
    return () => clearInterval(t)
  }, [signals.length, pruneSignals])

  if (!signals.length) return null
  return (
    <>
      {signals.map((s) => (
        <Html
          key={s.id || s.expiresAt}
          position={[s.pos?.x ?? 0, 2.2, s.pos?.z ?? 0]}
          center
          zIndexRange={[30, 10]}
          style={{ pointerEvents: 'none' }}
        >
          <div style={{ animation: 'kiwi-signal 4s ease-out forwards', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <SignalGlyph kind={s.kind} size={s.from === 'victor' ? 40 : 30} />
            {s.from === 'victor' && (
              <span style={{ fontSize: 9, letterSpacing: '0.18em', color: '#fde68a', textShadow: '0 1px 3px rgba(0,0,0,0.8)' }}>victor</span>
            )}
          </div>
          <style>{`@keyframes kiwi-signal {
            0% { opacity: 0; transform: translateY(8px) scale(0.85); }
            10% { opacity: 1; transform: translateY(0) scale(1); }
            78% { opacity: 1; }
            100% { opacity: 0; transform: translateY(-12px) scale(0.95); }
          }`}</style>
        </Html>
      ))}
    </>
  )
}

export default SignalMarks
